import { Table } from "antd";

export const DATable = Table;
